export default function AboutStory() {
  const milestones = [
    {
      year: '2021',
      title: 'Kuruluş — İzmir',
      desc: 'BIFF Digital İzmir\'de kuruldu. İlk projelerle birlikte strateji, kreatif ve performansı tek sistemde birleştirme fikri hayata geçti.',
      icon: 'ri-rocket-line',
    },
    {
      year: '2023',
      title: 'Ankara Merkez',
      desc: 'Ankara ofisi açıldı ve merkez haline getirildi. Endüstriyel ve B2B pazarlama odağında Ankara\'dan Türkiye geneline hizmet verilmeye başlandı.',
      icon: 'ri-building-2-line',
    },
    {
      year: '2024',
      title: 'İstanbul Ofisi',
      desc: 'İstanbul ofisi açıldı. Ankara, İstanbul ve İzmir üçgeninde çok şehirli bir yapıya geçildi.',
      icon: 'ri-global-line',
    },
    {
      year: 'Bugün',
      title: 'Çok Şehirli Büyüme',
      desc: 'Ankara, İstanbul ve İzmir\'de aktif; ulusal ve uluslararası ölçekte büyümek isteyen markalarla birlikte çalışmaya devam ediyoruz.',
      icon: 'ri-star-line',
    },
  ];

  return (
    <section id="hikaye" className="section-padding bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 md:mb-14 text-center">
          <p className="text-primary-500 font-bold text-sm tracking-[0.2em] uppercase mb-2">
            TARIHÇE
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-4">
            HIKAYEMIZ
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            2021'de İzmir'de kurulduk, 2023'te Ankara'yı merkez yaptık, 2024'ten itibaren İstanbul ofisiyle büyümeye devam ediyoruz.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Center line - desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-background-200 -translate-x-1/2" />

          <div className="space-y-8 md:space-y-12">
            {milestones.map((m, idx) => {
              const isLeft = idx % 2 === 0;
              return (
                <div key={idx} className={`relative flex flex-col md:flex-row items-center gap-4 md:gap-8 ${isLeft ? '' : 'md:flex-row-reverse'}`}>
                  {/* Content card */}
                  <div className={`w-full md:w-[calc(50%-2rem)] ${isLeft ? 'md:text-right' : 'md:text-left'}`}>
                    <div className="glass-card-hover rounded-2xl p-5 md:p-6">
                      <span className="inline-block px-3 py-1 bg-primary-500 text-foreground-950 text-sm font-bold rounded-lg mb-3">
                        {m.year}
                      </span>
                      <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-2">
                        {m.title}
                      </h3>
                      <p className="text-sm text-foreground-400 leading-relaxed">
                        {m.desc}
                      </p>
                    </div>
                  </div>

                  {/* Center dot */}
                  <div className="hidden md:flex shrink-0 w-10 h-10 bg-primary-500 rounded-full items-center justify-center z-10">
                    <i className={`${m.icon} text-foreground-950 text-lg`} />
                  </div>

                  {/* Spacer for alignment */}
                  <div className="hidden md:block w-[calc(50%-2rem)]" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}